module.exports = __webpack_public_path__ + "img/soporte_asesorias.986f7b90.png";